/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class CustomTranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  private loadJsonTranslations(lang: string): Observable<any> {
    const normalizedLang = (lang || 'en').trim();
    const baseLang = normalizedLang.split('-')[0];
    const languageCandidates = normalizedLang === baseLang ? [baseLang] : [normalizedLang, baseLang];

    return this.http.get<any>(`./assets/i18n/${languageCandidates[0]}.json`).pipe(
      catchError(() => {
        if (languageCandidates.length === 1) {
          return of({});
        }

        return this.http.get<any>(`./assets/i18n/${languageCandidates[1]}.json`).pipe(
          catchError(() => of({})),
        );
      }),
    );
  }

  getTranslation(lang: string): Observable<any> {
    const jsonTranslations$ = this.loadJsonTranslations(lang);

    // Load the disclaimer text file
    //check if the language has a disclaimer txt available if not set the english as default
    const disclaimerLang = (lang || 'en').split('-')[0];
    const supportedDisclaimerLang = disclaimerLang.match(/^(en|de)$/) ? disclaimerLang : 'en';
    const disclaimerUrl = `./assets/i18n/disclaimer_${supportedDisclaimerLang}.txt`;
    const disclaimer$ = this.http.get(disclaimerUrl, { responseType: 'text' });

    // Combine JSON and text file results
    return forkJoin({ json: jsonTranslations$, disclaimer: disclaimer$ }).pipe(
      map((response) => {
        // Merge JSON translations with the disclaimer text
        return {
          ...response.json,
          disclaimer: response.disclaimer.trim(),
        };
      }),
    );
  }
}
export function createTranslationLoader(http: HttpClient) {
  return new CustomTranslationLoader(http);
}
